export default function PHP_inet_ntop() {
  return (
    <div>
      <h1>PHP_inet_ntop</h1>
    </div>
  );
}
